import styles from './ImpactSelect.module.css'

interface ImpactSelectProps {
    id?: string
    value: string
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
    disabled?: boolean
    children: React.ReactNode
    className?: string
    variant?: 'light' | 'dark'
    'aria-label'?: string
}

const ImpactSelect: React.FC<ImpactSelectProps> = ({
    id,
    value,
    onChange,
    disabled = false,
    children,
    className = '',
    variant = 'light',
    'aria-label': ariaLabel,
}) => {
    const variantClass = variant === 'dark' ? styles.selectDark : styles.selectLight

    return (
        <select
            id={id}
            className={`${variantClass} ${className}`}
            value={value}
            onChange={onChange}
            disabled={disabled}
            aria-label={ariaLabel}
        >
            {children}
        </select>
    )
}

export default ImpactSelect
